import { takeLatest } from 'redux-saga/effects';
import {
    COST_ACCOUNTING_ACTION_REQUEST,
    FETCH_COST_ACCOUNTING_AUDIT_REQUEST,
    FETCH_COST_ACCOUNTING_ENTRIES_REQUEST,
    FETCH_COST_ACCOUNTING_PERIODS_REQUEST,
    FETCH_COST_ACCOUNTING_PROFITABILITY_REQUEST,
} from '../../redux/modules/costAccounting/costAccounting-actions';
import {
    costAccountingActionWorker,
    fetchCostAccountingAuditWorker,
    fetchCostAccountingEntriesWorker,
    fetchCostAccountingPeriodsWorker,
    fetchCostAccountingProfitabilityWorker,
} from './costAccountingWorkerSaga';

export function* fetchCostAccountingPeriodsWatcher() {
    yield takeLatest(FETCH_COST_ACCOUNTING_PERIODS_REQUEST, fetchCostAccountingPeriodsWorker);
}

export function* fetchCostAccountingEntriesWatcher() {
    yield takeLatest(FETCH_COST_ACCOUNTING_ENTRIES_REQUEST, fetchCostAccountingEntriesWorker);
}

export function* fetchCostAccountingAuditWatcher() {
    yield takeLatest(FETCH_COST_ACCOUNTING_AUDIT_REQUEST, fetchCostAccountingAuditWorker);
}

export function* fetchCostAccountingProfitabilityWatcher() {
    yield takeLatest(FETCH_COST_ACCOUNTING_PROFITABILITY_REQUEST, fetchCostAccountingProfitabilityWorker);
}

export function* costAccountingActionWatcher() {
    yield takeLatest(COST_ACCOUNTING_ACTION_REQUEST, costAccountingActionWorker);
}
